/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import { PlayerPhoto } from 'common/react/components/PlayerPhoto';
import { useGetImageScale } from '../hooks/use-get-image-scale';

/**
 * Renders a player's name and their photo.
 *
 * @param player.player
 * @param {object} player The player data object.
 * @param {string} reason The reason the player is removed, e.g. 'injury'.
 * @param player.reason
 * @returns {JSX.Element} The player name and photo.
 */
export const InsOutsPlayer = ({ player, reason }) => {
    const imageScale = useGetImageScale();

    return (
        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
            <div className="team-lineups-ins-and-outs__player-name-wrapper">
                <p className="team-lineups-ins-and-outs__player-name">
                    {player.playerName.givenName} {player.playerName.surname}
                </p>
                {reason ? (
                    <p className="team-lineups-ins-and-outs__player-reason">
                        {reason}
                    </p>
                ) : null}
            </div>
            <div className="team-lineups-ins-and-outs__headshot">
                <PlayerPhoto
                    photoUrl={player?.photoURL}
                    alt={`${player?.playerName?.givenName} ${player?.playerName?.surname}`}
                    scale={imageScale}
                />
            </div>
        </div>
    );
};

InsOutsPlayer.propTypes = {
    player: PropTypes.object.isRequired,
    reason: PropTypes.string
};
